module.exports = __webpack_public_path__ + "img/male.923a63e8.svg";